import { gql } from '@apollo/client';

export const PUBLICATION_FRAGMENT = gql`
  fragment TPublication on Publication {
    id
    fileId
    createdAt
    fileUrl
    userId
    isMy
    isSaved
    reuseCount
  }
`;

export const USER_FRAGMENT = gql`
  fragment TUser on User {
    id
    firstName
    userName
    meIsSubscribed
    subscribers
    subscriptions
  }
`;

export const AVATAR_FRAGMENT = gql`
  fragment TAvatar on Avatar {
    id
    name
    gender
  }
`;

export const PROFILE_FRAGMENT = gql`
  fragment TProfile on Profile {
    id
    imageGenerationsLeft
    videoGenerationsCount
    lorasLeft
    lang
    acitveLoraId
    botName
    brandName
    isAdmin
    firstName
    subscribers
    subscriptions
    userName
    isAcitveStartFunnel
    createdAt
    subscribers
    subscriptions
    avatars {
      ...TAvatar
    }
    userPromoInfo {
      activePromos {
        id
        description
        endDate
        videoGenerationTypes
        imageGenerationTypes
        name
        remainingGenerations
        totalGenerations
      }
    }
  }
`;

export const TImageGeneration = gql(`
  fragment TImageGeneration on ImageGeneration {
    id
    images
    publishedFileIds
    status
    type
    publishedFileIdsRepostCount
  }
`);

export const TVideoGeneration = gql(`
  fragment TVideoGeneration on VideoGeneration {
    id
    video
  }
`);

export const STYLE_FRAGMENT = gql`
  fragment TStyle on Style {
    id
    name
    imageWoman
    imageManAndMan
    imageManAndWoman
    imageWomanAndMan
    imageWomanAndWoman
    previewWoman
    imageMan
    previewMan
    examplesWoman
    examplesMan
    isNew
    isPopular
    gendersShown
    isActual
    positionActual
    isBest
    positionBest
    isLimited
    limitedUntil
    styleCategoryId
  }
`;

export const EFFECT_FRAGMENT = gql`
  fragment TEffect on Effect {
    id
    name
    imageWoman
    imageMan
    imageManAndMan
    imageManAndWoman
    imageWomanAndMan
    imageWomanAndWoman
    isNew
    isPopular
    gendersShown
    isActual
    positionActual
    isBest
    isFreeStickerPack
    positionBest
    isInputUserName
    isInputAccessory
    priceGeneration
    isStickerPack
    isLimited
    limitedUntil
    requiredImageCount
    styleCategoryId
  }
`;

export const PHOTO_SESSION_FRAGMENT = gql`
  fragment TPhotoSession on PhotoSession {
    id
    name
    imageWoman
    previewWoman
    imageMan
    previewMan
    examplesWoman
    examplesMan
    isNew
    isPopular
    gendersShown
    isActual
    positionActual
    isBest
    positionBest
    isLimited
    limitedUntil
    generationSource
  }
`;

export const VIDEO_LOOK_FRAGMENT = gql`
  fragment TVideoLook on VideoLook {
    id
    name
    imageWoman
    imageMan
    examplesWoman
    examplesMan
    isNew
    isPopular
    showResolutions
    gendersShown
    isActual
    positionActual
    isBest
    positionBest
    isLimited
    limitedUntil
    styleCategoryId
  }
`;

export const VIDEO_STYLE_FRAGMENT = gql`
  fragment TVideoStyle on VideoStyle {
    id
    name
    examplesWoman
    examplesMan
    videoWoman
    videoMan
    isNew
    isPopular
    gendersShown
    isActual
    showResolutions
    positionActual
    isBest
    positionBest
    isLimited
    limitedUntil
    styleCategoryId
  }
`;

export const VIDEO_VEO3_FRAGMENT = gql`
  fragment TVideoVeo3 on VideoVeo3 {
    id
    name
    examplesWoman
    examplesMan
    videoWoman
    videoMan
    isNew
    isPopular
    gendersShown
    isActual
    showResolutions
    positionActual
    isBest
    positionBest
    isLimited
    limitedUntil
    styleCategoryId
  }
`;

export const COMBI_VIDEO_FRAGMENT = gql`
  fragment TCombiVideo on CombiVideo {
    id
    name
    examplesWoman
    examplesMan
    imageWoman
    imageMan
    isNew
    isPopular
    gendersShown
    isActual
    positionActual
    isBest
    positionBest
    isLimited
    limitedUntil
  }
`;

export const STYLE_CATEGORY_FRAGMENT = gql`
  fragment TStyleCategory on StyleCategory {
    id
    name
    isNew
    isPopular
    gendersShown
    styles {
      ...TStyle
    }
    videoLooks {
      ...TVideoLook
    }
    videoStyles {
      ...TVideoStyle
    }
    effects {
      ...TEffect
    }
  }
`;

export const TRENDING_FRAGMENT = gql`
  fragment TTrendingItem on TrendingItem {
    id
    name
    maleGifUrl
    maleAndMaleGifUrl
    femaleAndMaleGifUrl
    maleAndFemaleGifUrl
    femaleAndFemaleGifUrl
    femaleGifUrl
    type
    gendersShown
    relationId
    position
  }
`;

// export const IMAGE_GENERATION_PACK_FRAGMENT = gql`
//   fragment TImageGenerationPack on ImageGenerationPack {
//     currency
//     discount
//     imageGenerations
//     isHot
//     price
//     id
//   }
// `;

// export const PAYMENT_SYSTEM_FRAGMENT = gql`
//   fragment TPaymentSystem on PaymentSystem {
//     id
//     name
//     image
//     isP2P
//     isCrypto
//   }
// `;

export const STORY_LINE_FRAGMENT = gql`
  fragment TStoryLine on StoryLine {
    id
    name
    nameFull
    gendersShown
    isNew
    isActual
    isPopular
    positionActual
    isBest
    positionBest
    isLimited
    limitedUntil
    previewMan
    previewWoman
    position
    createdAt
    updatedAt
    externalId
    examplesMan
    examplesWoman
  }
`;

export const PAYMENT_FRAGMENT = gql`
  fragment TPayment on Payment {
    id
    imageGenerations
    loras
    amount
    paymentUrl
    isForGenerations
    isForLora
    initialCurrency
    initialAmount
  }
`;
